import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";
import { useTranslations, useLocalizedData } from "contexts/LocalizationContext/hooks";
import { useModal } from "contexts/ModalContext";
import { trackEvents } from "utils/trackingUtils";
import SectionHeader from "modules/common/components/SectionHeader";
import Grid from "modules/common/components/Grid";
import Modal from "modules/help-a-friend/components/Modal";
import { SHARE_NOW_HELP_A_FRIEND_GTM, SHARE_NOW_HELP_A_FRIEND_MP } from "modules/help-a-friend/trackingConsts";
import { useReferralProgramConfig } from "contexts/DataContext/hooks";

const { Box, Button, Image, Stack, Text } = Chakra;

const HelpAFriend = () => {
  const translations = useTranslations();
  const { getLocalizedCurrency } = useLocalizedData();
  const { openModal } = useModal();

  const referralProgramConfig = useReferralProgramConfig();
  const { commissionValue } = referralProgramConfig;

  const clickHandler = () => {
    openModal(<Modal />, "md");
    trackEvents({ gtmEvent: SHARE_NOW_HELP_A_FRIEND_GTM, mixpanelEvent: SHARE_NOW_HELP_A_FRIEND_MP });
  };

  return (
    <Grid mb={24}>
      <Box gridColumn={{ base: "initial", md: "1 / span 6" }} display={{ base: "none", md: "initial" }}>
        <Image
          data-testid="friend-img-at-airport"
          gridColumn={{ base: "initial", md: "span 6" }}
          width="100%"
          boxShadow="sharpBlue"
          src={`${config.staticUrl}/i/referral-lp/help-a-friend-out.jpg`}
          alt={translations("help_a_friend_image_alt")}
          title={translations("help_a_friend_image_alt")}
          loading="lazy"
        />
      </Box>
      <Stack gridColumn={{ base: "initial", md: "8 / span 5" }} spacing={8} justify="center">
        <SectionHeader
          data-testid="friend-header"
          header={translations("help_a_friend_chances_are")}
          preheader={translations("help_a_friend")}
        />
        <Text
          dangerouslySetInnerHTML={{
            __html: translations("help_a_friend_every_month", {
              "%commission%": getLocalizedCurrency(commissionValue, "EUR"),
            }),
          }}
        />
        <Box>
          <Button
            data-testid="friend-share-now"
            px={10}
            width={{ base: "100%", md: "initial" }}
            onClick={clickHandler}
            title={translations("button_share_now")}
          >
            {translations("button_share_now")}
          </Button>
        </Box>
        <Box gridColumn={{ base: "initial", md: "1 / span 6" }}>
          <Image
            display={{ base: "initial", md: "none" }}
            width="100%"
            mt={{ base: "4" }}
            boxShadow="sharpBlue"
            src={`${config.staticUrl}/i/referral-lp/help-a-friend-out.jpg`}
            alt={translations("help_a_friend_image_alt")}
            title={translations("help_a_friend_image_alt")}
          />
        </Box>
      </Stack>
    </Grid>
  );
};

export default HelpAFriend;
